import HttpService from 'ui-home/src/misc/HttpService/HttpService';
import { removeMenuById, removeMenuByIds } from '../utils/removeMenuByID/removeMenuByID';

export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags) => (dispatch) => {
  dispatch(sideMenuLoading());
  const response = HttpService.get('/ECM/navigation/leftNav');

  const MENU_TO_ALLOW_IF_PAM_ENABLED = ['assets-sessions', 'privileged-service-account-management'];
  const MENU_TO_ALLOW_IF_PAM_DISABLED = [
    'new-privileged-access',
    'privileged-sessions',
    'past-sessions',
  ];
  const PAM_MENUS_TO_DISALLOW_IF_JFA_ENABLED = ['manage-pam'];
  const ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED = MENU_TO_ALLOW_IF_PAM_ENABLED.concat(
    MENU_TO_ALLOW_IF_PAM_DISABLED
  ).concat(PAM_MENUS_TO_DISALLOW_IF_JFA_ENABLED);

  const { isPamGen2, isJitForApps, isEmergencyRolesUser } = featureFlags;

  response.then((res) => {
    let sideMenu = [...res.topLevel];

    if (isJitForApps && isPamGen2) {
      const pamGen2SubMenu = sideMenu
        .filter((menu) => menu.id === 'home')[0]
        .subMenu.find((subMenuItem) => subMenuItem.id === 'privileged-access');

      // TODO: add localization for JITA and remove subMenuItem id overwrite in future
      pamGen2SubMenu.id = 'jit-access';
      pamGen2SubMenu.link = '/request/privilegedAccess';

      sideMenu = removeMenuByIds(sideMenu, ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED);
    } else if (isPamGen2) {
      sideMenu = removeMenuByIds(sideMenu, MENU_TO_ALLOW_IF_PAM_DISABLED);
    }
    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  });
};

export { InitializeSideMenu };
